export default __webpack_public_path__ + "img/63de25d2af06e6a7.4e9732474c910a9cb664c30b53e3abcd.jpeg";